import React from "react";
import NavBar from "../components/NavBar";
import PageHeader from "../components/PageHeader";
import PolicyLinks from "../components/PolicyLinks";
import PageFooter from "../components/PageFooter";
import CollectionsMenu from "../components/CollectionsMenu";

function MainLayout({ children }) {
  return (
    <div className="site-container">
      <CollectionsMenu></CollectionsMenu>
      <PageHeader></PageHeader>
      <div className="page-content">{children}</div>
      <PolicyLinks></PolicyLinks>
      <PageFooter></PageFooter>
    </div>
  );
}

export default MainLayout;
